// Modules
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useParams, Redirect } from 'react-router-dom';

// Styled Components
import { BackgroundView, Container } from './events.styles';

// Components

import Loading from '../components/loading/loading.component';

// Constant
import { isValidLang } from '../utils/common.utils';
// Selectors
import { capitalizedLang } from '../selectors/common.selector';

//Reducers
import { SET_DIRECTION, SET_LANGUAGE } from '../store/reducers/common.reducer';
import { getEvent } from '../store/reducers/event.reducer';
import { Store } from '../types/store';
import { EventProps, Event } from '../types/events';
import EventCardLg from '../components/event-card-lg/event-card-lg.component';
import EventContent from '../components/event-content/event-content.component';
import EventFooter from '../components/event-footer/event-footer.component';

const EventDetailScreen = () => {
	const dispatch = useDispatch();
	const location = useLocation();
	const params: any = useParams();
	const [data, setData] = useState(new Event({} as EventProps));

	// Dispatcher
	const lang = useSelector((state: any) => capitalizedLang()(state));
	const included = useSelector(
		(state: any) => state.event.selectedEventIncluded,
	);
	const dir = useSelector((state: any) => state.common.dir);
	const facets = useSelector((state: any) => state.facet);

	// Selector
	const event: EventProps = useSelector(
		(state: Store) => state.event.selectedEvent,
	);

	useEffect(() => {
		let language = params.lang === 'en' || params.lang ===  'fr' ? 'en' : 'he';		
		const direction = language === 'en'  ? 'ltr' : 'rtl';
		document.documentElement.lang = language;
		document.documentElement.dir = direction;
		dispatch({ type: SET_DIRECTION.type, payload: direction });
		dispatch({ type: SET_LANGUAGE.type, payload: language });
		if (params.eventId) {
			dispatch(getEvent(params.eventId));
		}
	}, [location]);

	useEffect(() => {
		setData(new Event({ ...event, lang, included, facets }));
	}, [event, included, facets]);
	
		
	if (params.lang && !isValidLang(params.lang)){
		return <Redirect to={`/event/${params.eventId}`} />
	}

	return (
		<BackgroundView>
			<Container>
				{data.hasData ? (
					<>
						<EventCardLg
							enableArrow={false}
							enableDate={false}
							enableType={false}
							event={data}
							enableColorInvert={false}
						/>
						<EventContent event={data} />
						<EventFooter event={data} language={lang} dir={dir} />
					</>
				) 
				: <Loading />}
			</Container>
		</BackgroundView>
	);
};

export default EventDetailScreen;
